export default __webpack_public_path__ + "static/media/powerpoint.6fbb7ab6.png";